import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText)

export class TextReveal {
	constructor(element, options) {
		this.options = {
			manualReveal: false,
			trigger: false,
			timeoutDelay: 100,
			resetSplitAfter: true,
			...options,
		}
		this.element = element

		if (this.options.manualReveal) {
			this.options.trigger = false
		}

		this.prepare()
		// this.reveal()

		this.isRevealed = false

		this.element.classList.add('has-text-reveal')

		this.timeoutId = null
		this.revealTimeoutId = null

		if (this.options.trigger) {
			this.timeoutId = setTimeout(() => {
				this.initTrigger()
			}, this.options.timeoutDelay)
		}
		// setTimeout(() => {
		// 	this.prepare()
		// }, 1300)
	}

	prepare() {
		this.element.style.visibility = 'hidden'
		this.element.style.display = 'inline-block' // Or block if needed
		this.element.style.whiteSpace = 'normal'

		// Step 2: Trigger a reflow
		this.element.offsetHeight

		// Step 3: Split into lines
		this.splitText = new SplitText(this.element, {
			type: 'lines',
			tag: 'div',
			linesClass: 'line',
			reduceWhiteSpace: false,
		})
		// Step 4: Reveal again
		this.element.style.visibility = ''

		this.lines = this.splitText.lines

		if (!this.isRevealed) {
			this.lines.forEach((line) => {
				line.style.opacity = 0
			})
		}
	}
	initTrigger() {
		this.trigger = ScrollTrigger.create({
			trigger: this.element,
			start: 'top 80%',
			end: 'bottom 20%',
			onEnter: () => {
				if (!this.isRevealed) {
					this.reveal()
				}
			},
			onLeaveBack: () => {},
		})
	}
	refresh() {}
	reveal(delay) {
		const self = this

		if (delay) {
			this.revealTimeoutId = setTimeout(() => {
				this.reveal()
			}, delay)
			return
		}

		const tl = gsap.timeline({
			onComplete: () => {
				this.isRevealed = true
				if (this.options.resetSplitAfter) {
					self.splitText.revert()
				}
			},
		})

		// Animate vertical motion first
		tl.fromTo(
			this.lines,
			{ yPercent: 40 },
			{
				yPercent: 0,
				duration: 1,
				force3D: true,
				roundProps: 'y',
				ease: 'power4.out',
				stagger: 0.1,
			},
			0
		) // Start at time 0

		// Animate opacity slightly later
		tl.to(
			this.lines,
			{
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out',
				stagger: 0.1,
			},
			0
		) // Start slightly after motion starts

		// gsap.fromTo(
		// 	this.lines,
		// 	{ opacity: 0, yPercent: 30 },
		// 	{
		// 		yPercent: 0,
		// 		opacity: 1,
		// 		duration: 5,
		// 		force3D: true,
		// 		ease: 'power4.out',
		// 		stagger: 0.05,
		// 		onComplete: () => {
		// 			// this.splitText.revert()
		// 		},
		// 	}
		// )

		// setTimeout(() => {
		// 	self.splitText.revert()
		// }, 1000)
	}
	destroy() {
		if (this.trigger) {
			this.trigger.kill(true)
			this.trigger = null
		}
		if (this.splitText) {
			this.splitText.revert()
			this.splitText = null // Clear the reference

			// this.splitText.destroy(true)
		}

		if (this.timeoutId) {
			clearTimeout(this.timeoutId) // Clear the timeout
			this.timeoutId = null
		}

		if (this.revealTimeoutId) {
			clearTimeout(this.revealTimeoutId) // Clear the timeout
			this.revealTimeoutId = null
		}

		if (this.element) {
			this.element.style.visibility = ''
			this.element.style.display = ''
			this.element.style.whiteSpace = ''
			this.element.classList.remove('has-text-reveal')
		}
	}
}
